import React from "react";

const Privacy = () => {
  return (
    <main className="container" style={{ fontFamily: "Trebuchet MS" }}>
      <h1 class="display-4 text-success">Privacy Notice</h1>
      <h2 class="text-success">Who are we?</h2>
      <p>
        This web application https://ftr-app.azurewebsites.net (the
        “Application”) is owned and operated by British Sugar plc (registered in
        England and Wales under company number 315158) ( “we”, “our” or “us”).
      </p>
      <h2 class="text-success">Purpose of this notice</h2>
      <p>
        This privacy notice tells you about the information we collect about you
        when you visit our Application or otherwise provide us with information.
        It also tells you how you can exercise Your Rights (including the right
        to object to some of the data handling we carry out).
      </p>
      <h2 class="text-success">What personal data do we collect?</h2>
      <h3 class="text-success">
        Site traffic data and information about your computer
      </h3>
      <h4>How do we use this data?</h4>
      <p>
        When you browse our Application, we use cookies to collect standard
        internet log information, account activity and details of visitor
        behaviour patterns. We collect this information for the purpose of our
        legitimate interests in maintaining and managing our Application and
        ensuring its security. We also use this information to record visitor
        numbers, their use of different areas of the Application and any useful
        features or links. We do not use this information in any way that would
        identify you personally. For more information about how we use cookies
        on our Application, see our Cookies Policy.
      </p>
      <h4>How long do we keep this information for?</h4>
      <p>
        We will only keep information about your visit to our Application for as
        long as is necessary for the purposes we’ve mentioned.
      </p>
      <h4>Who do we share this information with?</h4>
      <p>
        We do not share information about visitors to our Application with any
        service providers.
      </p>
      <h4>Where do we transfer this information to?</h4>
      <p>
        Information we collect about your use of our Website is stored within,
        and not transferred outside of, the European Economic Area..
      </p>
      <h3 class="text-success">
        Information you give us when you register to use our Application
      </h3>
      <h4>How do we use this data?</h4>
      <h4>Application registration</h4>
      <p>
        If you would like to register to use the Application, we require you to
        supply us with your contact details including your name and email
        address. We also ask you to confirm why the Application is of interest
        to you; this information is deleted once your registration has been
        successful and it is not used for direct marketing purposes.
      </p>
      <p>
        From time to time we may ask you to supply us with additional
        information that is not strictly necessary in order for us manage your
        access to the Application. Additional information can be useful to us in
        helping us learn more about the community or to help us enhance our
        online services. If we do ask you for information that is not strictly
        necessary for the management of your Application registration we will
        make it clear that the supply of this information is optional.
      </p>
      Personal data you supply when you register to use the Application will be
      used:
      <ul>
        <li>
          to manage your access to the Application and /or your access to your
          online account;
        </li>
        <li>
          to improve our understanding of the needs and interests of the
          community and;
        </li>
        <li>to notify you about changes to our services.</li>
      </ul>
      <p>
        When we use your personal data for these purposes, we do so for our
        legitimate interests in managing and administering the Application
        and/or your online account and for our legitimate business interests in
        developing and promoting our business. You can object to our use of your
        data for these purposes at any time.
      </p>
      <p>
        We will also use this data for the purpose of our legitimate interests
        in accessing appropriate professional advice and in order to ensure we
        comply with legal obligations to which our business is subject.
      </p>
      <h4>How long do we keep this information for?</h4>
      <p>
        Information we hold for the purpose of managing your access to the
        Application is held by us for up to 24 months following the closure or
        deactivation of your registration and/or online account.
      </p>
      <h4>Who do we share this information with?</h4>
      <p>
        We share this data where necessary with our suppliers, service providers
        and professional advisers. Otherwise we will not share your information
        with any third party unless:
      </p>
      <ul>
        <li>we have your permission;</li>
        <li>we are required to do so by law;</li>
        <li>
          this is necessary so that we can enforce our terms of use, rights or
          property or the rights or property of any third party; or
        </li>
        <li>
          this is necessary in connection with the sale of our business or its
          assets (in which case your details will be disclosed to our advisers
          and any prospective purchaser’s advisers and will be passed to the new
          owners).
        </li>
      </ul>
      <h4>Where do we transfer this information to?</h4>
      <p>
        Information we collect when you register to use the Application is
        stored within, and not transferred outside of, the European Economic
        Area.
      </p>
      <h3 class="text-success">Your Rights</h3>
      <p>
        You can ask us at any time to provide you with a copy of your personal
        data. In relation to personal data you have supplied to us, and which is
        held by us for the purpose of entering into a contract between us or on
        the basis of your consent, you are entitled to ask us for a copy of this
        information in a structured, commonly used and machine readable format
        so that you can reuse it or share it with other organisations.
      </p>
      <p>
        If you think the personal data we hold about you is inaccurate or
        incomplete, you can ask us to correct it or complete it. In some
        circumstances you also have the right to object to our processing of
        your data and can ask us to restrict our use of your data and to delete
        it.
      </p>
      <p>
        There are some exceptions to these rights, however. For example, it will
        not be possible for us to delete your data if we are required by law to
        keep it or if we hold it in connection with a contract with you.
        Similarly, access to your data may be refused if making the information
        available would reveal personal information about another person or if
        we are legally prevented from disclosing such information.
      </p>
      <p>
        If you wish to exercise any of these rights you should contact us by
        email at Rhys.Oliver@britishsugar.com
      </p>
      <h3 class="text-success">Contacting us and your rights of complaint</h3>
      <p>
        Questions, comments or requests concerning this privacy notice are
        welcomed and should be addressed to Technical Applications Manager via
        Rhys.Oliver@britishsugar.com If you have a concern about the way we
        handle your personal data you have the right to complain to the
        Information Commissioner (ICO). You can find details of how to do this
        on the ICO website at https://ico.org.uk/concerns/ or by calling their
        helpline on 0303 123 1113.
      </p>
      <hr />
      <p>This privacy notice was last updated on 1st October 2020</p>
    </main>
  );
};

export default Privacy;
